import {TFunction} from 'i18next';

import {OrganizationTemplateItemTypes} from 'appRedux/actions/organization/types';

export const TYPE_AGENT_GET_CHAT_MESSAGE = 1;
export const TYPE_INVITE_FOR_REGISTRATION = 2;
export const TYPE_SUCCESSFULLY_SUBMITTED = 3;
export const TYPE_INVITE_ADDITIONAL_FORM = 4;
export const TYPE_APPROVE_STATUS_CHANGING = 5;
export const TYPE_SUBFORM_PAGES_ATTACHED = 6;
export const TYPE_SUBFORM_PAGES_AUTO_APPENDING = 7;
export const TYPE_IMPERSONATED_CASE_CREATED = 8;
export const TYPE_ACCOUNT_DELETING = 9;
export const TYPE_AGENT_ASSIGNED = 10;
export const TYPE_AGENT_CHAT_MESSAGE = 11;
export const TYPE_INVITE_REGISTRATION = 12;
export const TYPE_ORGANIZATION_ACCOUNT_CREATED = 13;
export const TYPE_PASSWORD_RECOVERY = 14;
export const TYPE_VERIFICATION = 15;
export const TYPE_FORGET_NICKNAME = 16;
export const TYPE_TFA_DEACTIVATED = 17;
export const TYPE_ORGANIZATIONS_STATISTIC_REPORT = 18;
export const TYPE_CASES_QUOTA_HARD = 19;
export const TYPE_CASES_QUOTA_SOFT = 20;
export const TYPE_USER_ACCOUNT_REPORT = 21;
export const TYPE_USER_EMAIL_UPDATING = 22;
export const TYPE_CLIENT_SECTION_COMMENT = 23;
export const TYPE_REQUESTER_CASE_CALENDAR_BOOKING = 25;

export interface OrganizationTemplateListItemType {
    type: number;
    label: string;
}

export interface OrganizationTemplateTableItemType extends OrganizationTemplateListItemType {
    language: number;
    subject: string;
    text: string;
    uuid: string;
}

export const organizationTemplatesArray: OrganizationTemplateListItemType[] = [
    {
        type: TYPE_AGENT_GET_CHAT_MESSAGE,
        label: 'templates.userGetChatMessage.subject',
    },
    {
        type: TYPE_INVITE_FOR_REGISTRATION,
        label: 'templates.inviteForRegistration.subject',
    },
    {
        type: TYPE_SUCCESSFULLY_SUBMITTED,
        label: 'templates.caseSuccessfullySubmitted.subject',
    },
    {
        type: TYPE_INVITE_ADDITIONAL_FORM,
        label: 'templates.inviteAdditionalForm.subject',
    },
    {
        type: TYPE_APPROVE_STATUS_CHANGING,
        label: 'templates.requesterCaseApprove.subject',
    },
    {
        type: TYPE_SUBFORM_PAGES_ATTACHED,
        label: 'templates.caseSubFormAdded.subject',
    },
    {
        type: TYPE_SUBFORM_PAGES_AUTO_APPENDING,
        label: 'templates.caseSubFormAutoAppending.subject',
    },
    {
        type: TYPE_IMPERSONATED_CASE_CREATED,
        label: 'templates.impersonatedCaseCreated.subject',
    },
    {
        type: TYPE_ACCOUNT_DELETING,
        label: 'templates.accountDeletingRequest.subject',
    },
    {
        type: TYPE_AGENT_ASSIGNED,
        label: 'templates.agentAssignedToCase.subject',
    },
    {
        type: TYPE_AGENT_CHAT_MESSAGE,
        label: 'templates.userGetChatMessage.subject',
    },
    {
        type: TYPE_INVITE_REGISTRATION,
        label: 'templates.inviteForRegistration.subject',
    },
    {
        type: TYPE_ORGANIZATION_ACCOUNT_CREATED,
        label: 'templates.orgUserAccountCreated.subject',
    },
    {
        type: TYPE_PASSWORD_RECOVERY,
        label: 'templates.accountPasswordReset.subject',
    },
    {
        type: TYPE_VERIFICATION,
        label: 'templates.userVerification.subject',
    },
    {
        type: TYPE_FORGET_NICKNAME,
        label: 'templates.forgetNickname.subject',
    },
    {
        type: TYPE_TFA_DEACTIVATED,
        label: 'templates.twoFactorDeactivation.subject',
    },
    {
        type: TYPE_ORGANIZATIONS_STATISTIC_REPORT,
        label: 'templates.organizationStatisticReport.subject',
    },
    {
        type: TYPE_CASES_QUOTA_HARD,
        label: 'templates.requesterCasesQuotaHard.subject',
    },
    {
        type: TYPE_CASES_QUOTA_SOFT,
        label: 'templates.requesterCasesQuotaSoft.subject',
    },
    {
        type: TYPE_USER_ACCOUNT_REPORT,
        label: 'templates.userAccountExport.subject',
    },
    {
        type: TYPE_USER_EMAIL_UPDATING,
        label: 'templates.userUpdateEmail.subject',
    },
    {
        type: TYPE_CLIENT_SECTION_COMMENT,
        label: 'templates.clientGetSectionComment.subject',
    },
    {
        type: TYPE_REQUESTER_CASE_CALENDAR_BOOKING,
        label: 'templates.requesterCaseCalendarBooking.subject',
    },
];

export const getTemplateTypeLabel = (t: TFunction, item: OrganizationTemplateItemTypes): string => {
    const currentTemplateType = organizationTemplatesArray.find(template => template.type === item.type);
    return currentTemplateType ? t(currentTemplateType.label) : t('common.none');
};

export const getOrganizationTemplateTableItems = (
    organizationTemplates: OrganizationTemplateItemTypes[],
    language: number,
): OrganizationTemplateTableItemType[] => {
    const results: OrganizationTemplateTableItemType[] = [];
    organizationTemplatesArray.forEach(item => {
        const {type, label} = item;
        const currentTemplate = organizationTemplates.find(template => template.type === type);
        const subject = currentTemplate ? currentTemplate.subject : '';
        const text = currentTemplate ? currentTemplate.text : '';
        const uuid = currentTemplate ? currentTemplate.uuid : '';
        results.push({
            type,
            label,
            language,
            subject,
            text,
            uuid,
        });
    });
    return results;
};
